import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import api from "../../lib/api";
import { Loading, EmptyState } from "../../components/Shared";
import { inr } from "../../lib/api";

export default function PlansPage() {
  const [plans, setPlans] = useState(null);
  useEffect(() => { api.get("/public/plans").then((r) => setPlans(r.data)).catch(() => setPlans([])); }, []);
  if (!plans) return <Loading label="Loading plans…" />;
  return (
    <div className="p1-container py-14 lg:py-20" data-testid="plans-page">
      <div className="text-center">
        <p className="p1-eyebrow">Plans & Pricing</p>
        <h1 className="mt-3 font-heading text-3xl font-bold tracking-tight text-stone-900 sm:text-4xl lg:text-5xl">Simple plans. Serious care.</h1>
        <p className="mx-auto mt-4 max-w-2xl text-lg text-stone-600">Every plan starts with a free Parent Care Assessment so we recommend only what your parents truly need.</p>
      </div>
      {plans.length === 0 ? (
        <EmptyState title="Plans are being configured" body="Please talk to a care advisor for current pricing." />
      ) : (
        <div className="mt-12 grid gap-6 lg:grid-cols-3">
          {plans.map((p) => (
            <div key={p.id} className={`relative rounded-3xl border p-8 transition-shadow hover:shadow-lg ${p.highlighted ? "border-emerald-800 bg-emerald-950 text-white shadow-xl" : "border-stone-200 bg-white"}`}
              data-testid={`plan-card-${p.name.toLowerCase()}`}>
              {p.highlighted && <span className="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-terracotta px-4 py-1 text-xs font-bold uppercase tracking-wider text-white">Most chosen</span>}
              <h2 className="font-heading text-xl font-bold">{p.name}</h2>
              <p className="mt-3">
                <span className="font-heading text-4xl font-extrabold">{inr(p.price)}</span>
                <span className={`text-sm ${p.highlighted ? "text-stone-300" : "text-stone-500"}`}> /{p.period}</span>
              </p>
              <p className={`mt-1 text-xs ${p.highlighted ? "text-stone-300" : "text-stone-500"}`}>{p.visits_per_month} home & welfare visits per month</p>
              <ul className="mt-6 space-y-2.5">
                {(p.benefits || []).map((b) => (
                  <li key={b} className="flex items-start gap-2 text-sm">
                    <Check className={`mt-0.5 h-4 w-4 shrink-0 ${p.highlighted ? "text-emerald-300" : "text-emerald-700"}`} /> {b}
                  </li>
                ))}
              </ul>
              <Link to="/onboarding" data-testid={`plan-cta-${p.name.toLowerCase()}`}
                className={`mt-8 flex w-full items-center justify-center gap-2 rounded-full px-6 py-3 text-sm font-semibold transition-colors ${p.highlighted ? "bg-white text-emerald-950 hover:bg-stone-100" : "bg-emerald-900 text-white hover:bg-emerald-800"}`}>
                Start with a Free Assessment <ArrowRight className="h-4 w-4" />
              </Link>
            </div>
          ))}
        </div>
      )}
      <p className="mx-auto mt-10 max-w-2xl text-center text-sm text-stone-500">
        Add-on services (nursing, attendants, physiotherapy, ambulance, diagnostics) are provided and charged by verified third-party partners. Every plan includes a dedicated, verified Care Manager and full access to the ParentOne family platform.
      </p>
    </div>
  );
}
